var _excluded = ["thickness", "speed", "color", "emptyColor", "label"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import * as VisuallyHidden from '@radix-ui/react-visually-hidden';
import { keyframes, styled, forwardRef } from '@grupoboticario/flora-react-system';
var rotate = keyframes({
  '0%': {
    transform: 'rotate(0deg)'
  },
  '100%': {
    transform: 'rotate(360deg)'
  }
});
var StyledSpinner = styled('span', {
  display: 'inline-block',
  position: 'relative',
  borderRadius: '$pill',
  transform: 'translateZ(0)',
  borderStyle: 'solid',
  '&:after': {
    borderRadius: '$pill'
  },
  variants: {
    size: {
      xxs: {
        size: '$2'
      },
      xs: {
        size: '$4'
      },
      sm: {
        size: '$6'
      },
      md: {
        size: '$8'
      },
      lg: {
        size: '$10'
      },
      xl: {
        size: '$12'
      }
    }
  },
  defaultVariants: {
    size: 'xs'
  }
});

/**
 * @component
 * @name Spinner
 * @description Spinner component
 * @tutorial https://flora.gb.tech/docs/components/core/spinner
 */
export var Spinner = forwardRef((_ref, forwardedRef) => {
  var {
    thickness = '2px',
    speed = '0.8s',
    color = 'currentColor',
    emptyColor = 'transparent',
    label = 'Loading, please wait.'
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var borderColor = /^\$/.test(color) ? "$colors" + color : color;
  var emptyBorderColor = /^\$/.test(emptyColor) ? "$colors" + emptyColor : emptyColor;
  return /*#__PURE__*/React.createElement(StyledSpinner, _extends({
    "data-flora-spinner": true,
    "data-flora": "spinner"
  }, props, {
    ref: forwardedRef,
    css: _extends({}, props.css, {
      animation: rotate + " " + speed + " infinite linear",
      borderColor,
      borderBottomColor: emptyBorderColor,
      borderLeftColor: emptyBorderColor,
      borderWidth: thickness
    })
  }), /*#__PURE__*/React.createElement(VisuallyHidden.Root, null, props['aria-label'] || label));
});
//# sourceMappingURL=Spinner.js.map